import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LinesService } from './lines.service';
import { StopsService } from '../stops/stops.service';

@Component({
  selector: 'app-lines',
  templateUrl: './lines.component.html',
  styleUrls: ['./lines.component.css']
})
export class LinesComponent implements OnInit {
  liniaAutobusowa: Array<Lines> = [];
  constructor(private _router: Router, private linesService: LinesService, private stopsService: StopsService) {
    this.liniaAutobusowa = linesService.linieAutobusowe;
  }

  ngOnInit() {
  }
  onclick(i) {
    this._router.navigate(['lines' , i ]);
  }
}

export interface Lines {
  id: number;
  przystanki: Array<number>;
  czas: Array <string>;
}





// WEBPACK FOOTER //
// ./src/app/lines/lines.component.ts